import PurchaseRegistration from 'modules/purchase/PurchaseEdit';
import Header from 'modules/header/farm/main';
import React from 'react';

const PurchaseEditContainer = () => {
  return (
    <div className="flex w-full h-full flex-col">
      <Header title="آگهی‌ خرید محصول" />
      <PurchaseRegistration type="farmer" />
    </div>
  );
};

export default PurchaseEditContainer;
